(() => {
  if (window.__PSS_INIT__) return
  window.__PSS_INIT__ = true

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true })
    } else {
      fn()
    }
  }

  function hasJQAndSlick() {
    return typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.slick
  }

  function getCurrentVariantId() {
    // URL ?variant=
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const urlVariant = urlParams.get('variant')
      if (urlVariant) return String(urlVariant)
    } catch (e) {}

    // hidden input[name="id"]
    const hidden = document.querySelector('input[name="id"][type="hidden"]')
    if (hidden && hidden.value) return String(hidden.value)

    // select[name="id"]
    const variantSelect = document.querySelector('select[name="id"]')
    if (variantSelect && variantSelect.value) return String(variantSelect.value)

    // input[name="id"]:checked
    const variantInput = document.querySelector('input[name="id"]:checked')
    if (variantInput && variantInput.value) return String(variantInput.value)

    return null
  }

  function getMediaIdFromVariant(v) {
    if (!v) return null
    if (v.featured_media && v.featured_media.id) return v.featured_media.id
    if (v.featured_media_id) return v.featured_media_id
    return null
  }

  function findSlideByMediaId(mediaId) {
    const $ = window.jQuery
    let slideIndex = -1

    $('.product-media-item').each(function (index) {
      const itemMediaId = $(this).attr('data-media-id')
      if (itemMediaId && parseInt(itemMediaId, 10) === parseInt(mediaId, 10)) {
        slideIndex = index
        return false
      }
    })

    return slideIndex
  }

  function goToSlide(slideIndex) {
    const $ = window.jQuery
    if (slideIndex < 0) return false

    if (!$('.product-images-slider').hasClass('slick-initialized')) return false

    try {
      $('.product-images-slider').slick('slickGoTo', slideIndex, false)
      return true
    } catch (error) {
      console.error('[PSS] Error moving to slide:', error)
      return false
    }
  }

  function updateSliderForVariant(variantId) {
    const list = window.allVariants || []
    const v = list.find((x) => String(x.id) === String(variantId))

    const mediaId = getMediaIdFromVariant(v)
    if (!mediaId) return

    const slideIndex = findSlideByMediaId(mediaId)
    if (slideIndex >= 0) goToSlide(slideIndex)
  }

  function initializeSlider() {
    const $ = window.jQuery

    if (!$('.product-images-slider').length) return false
    if ($('.product-images-slider').hasClass('slick-initialized')) return true

    $('.product-images-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      adaptiveHeight: true,
      arrows: true,
      speed: 100,
      fade: true,
      cssEase: 'linear',
      infinite: false,
      prevArrow:
        "<button type='button' class='slider_left'><img src='https://cdn.shopify.com/s/files/1/0539/2967/2897/files/slider-icon-left.svg?v=1742994786' loading='lazy'></button>",
      nextArrow:
        "<button type='button' class='slider_right'><img src='https://cdn.shopify.com/s/files/1/0539/2967/2897/files/slider-icon-right.svg?v=1742994786' loading='lazy'></button>",
    })

    return true
  }

  function setupEventListeners() {
    const $ = window.jQuery

    if (window.__PSS_LISTENERS__) return
    window.__PSS_LISTENERS__ = true

    // 1) direct variant ID changes
    $(document).on('change', 'select[name="id"], input[name="id"]', function () {
      const variantId = $(this).val()
      if (variantId) updateSliderForVariant(variantId)
    })

    // 2) option selector change (theme updates hidden variant ID first)
    $(document).on('change', '.single-option-selector', function () {
      setTimeout(function () {
        const currentVariant =
          $('input[name="id"][type="hidden"]').val() ||
          $('select[name="id"]').val() ||
          $('input[name="id"]:checked').val()

        if (currentVariant) updateSliderForVariant(currentVariant)
      }, 80)
    })

    // 3) custom theme events
    $(document).on('variant:changed variantChanged variant:change', function (e, variant) {
      const v = variant || (e && e.detail && e.detail.variant)
      if (v && v.id) updateSliderForVariant(v.id)
    })

    // 4) URL changes (AJAX)
    let lastUrl = location.href
    new MutationObserver(() => {
      const url = location.href
      if (url !== lastUrl) {
        lastUrl = url
        const urlParams = new URLSearchParams(window.location.search)
        const variantId = urlParams.get('variant')
        if (variantId) updateSliderForVariant(variantId)
      }
    }).observe(document, { subtree: true, childList: true })
  }

  function initWhenReady() {
    if (!hasJQAndSlick()) return false

    initializeSlider()
    setupEventListeners()

    const initialVariant = getCurrentVariantId()
    if (initialVariant) {
      setTimeout(() => updateSliderForVariant(initialVariant), 50)
    }

    return true
  }

  onReady(() => {
    if (initWhenReady()) return

    let tries = 0
    const t = setInterval(() => {
      tries += 1
      if (initWhenReady() || tries >= 60) clearInterval(t) 
    }, 30)

    const sync = () => {
      const vId = getCurrentVariantId()
      if (vId) updateSliderForVariant(vId)
    }

    if (window.__variantsPromise__) {
      window.__variantsPromise__.then(sync).catch(() => {})
    } else {
      sync()
    }
  })
})()